<template>
  <div class="dropdown ml-5 mr-2" v-if="loaded">
    <button
      type="button"
      class="btn btn-secondary btn-sm dropdown-toggle"
      id="dropdownMenuOffset"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ map[type] }}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuOffset">
      <template v-for="(name, status) in map">
        <a
          v-if="status !== type"
          class="dropdown-item"
          href="#"
          @click.prevent="selectType(status)"
        >
          {{ name }}
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    defaultType: {
      type: String,
      required: false,
      default: 'product'
    }
  },
  data() {
    return {
      loaded: false,
      type: this.defaultType,
      map: {
        product: 'Produkt',
        own_product: 'Výrobek',
        service: 'Služba'
      }
    }
  },
  computed: {
    ...mapGetters({
      filters: 'filters/filters'
    })
  },
  mounted() {
    // if (this.user.tariff_plan.manufacturer_features) {
    //   this.type = 'own_product'
    //   this.map = {
    //     own_product: 'Výrobek',
    //     service: 'Služba'
    //   }
    // }

    setTimeout(() => {
      if (this.filters.type) {
        this.type = this.filters.type
      }
      this.loaded = true
    }, 250)
  },
  methods: {
    ...mapActions({
      updateURL: 'filters/updateURL'
    }),
    selectType(status) {
      this.updateURL({ type: status })
      window.location.reload(true)
    }
  }
}
</script>
